import cloneDeep from 'lodash/cloneDeep';
import { SavedView } from '@/app/modules/saved-views/types';
import { MetricsGridConfig } from '../core';
import {
  SavedViewDeserializer,
  SavedViewDeserializerResponse,
} from '@/app/modules/saved-views/types';

export const savedViewDeserializer: SavedViewDeserializer<MetricsGridConfig> = (
  config: MetricsGridConfig,
  view: SavedView
) => {
  console.log(
    'sales-reps.savedViewReducer  called with\n',
    config,
    '\nand view\n',
    view.columns
  );
  const newConfig = cloneDeep(config);
  newConfig.groups.forEach((group, index) => {
    const token = group.columnSelectorTitle || `__group_${index}__`;
    group.visible = view.columns.includes(token);
  });

  newConfig.groups.forEach((group) => {
    if (group.visible) {
      console.log('     ', `Group ${group.columnSelectorTitle} is visible`);
    }
  });

  const response: SavedViewDeserializerResponse<MetricsGridConfig> = {
    config: newConfig,
    sorting: {
      key: view.sort.length > 0 ? view.sort[0].key : null,
      direction: view.sort.length > 0 ? view.sort[0].direction : null,
    },
  };

  return Promise.resolve(response);
};
